import React from 'react';
import PropTypes from 'prop-types';
import ThemedInput from '../ThemedInput';

const isValid = (value, rule) => {
  const { checkValid, pattern } = rule;
  return checkValid && typeof checkValid === 'function'
    ? checkValid(value)
    : pattern.test(value);
};

// not used currently, but this might eventually be useful
export const buildHtmlPatternFromRegex = validation => {
  const patternRules = validation.filter(rule => !!rule.pattern) || [];
  const dominantPattern = (patternRules.length
    ? patternRules[patternRules.length - 1]
    : {}).pattern;

  return dominantPattern ? dominantPattern.source.replace(/^\^|\$$/g, '') : '';
};

const buildEventHandlers = props => {
  const { validation } = props;

  if (__DEV__ && validation.some(rule => !rule.events || !rule.events.length)) {
    // eslint-disable-next-line no-console
    console.error(
      'ValidatedInput: Each rule must have at least one associated event.'
    );
  }

  // build a list of unique events
  const events = (validation || []).reduce((acc, curr) => {
    const newValues = curr.events
      ? curr.events.filter(event => !acc.includes(event))
      : [];
    return [...acc, ...newValues];
  }, []);

  return events.reduce((acc, curr) => {
    // don't build a handler if no function was provided for it
    const eventFunction = props[curr];
    if (!eventFunction || typeof eventFunction !== 'function') {
      if (__DEV__) {
        // eslint-disable-next-line no-console
        console.error(`ValidatedInput: Missing handler for event ${curr}.`);
      }
      return acc;
    }

    return {
      ...acc,
      [curr]: arg => {
        // determine field value
        let value = arg;
        if (arg && arg.target) {
          value = arg.target.value;
        }

        // validate field
        const failedRule = (validation || [])
          .filter(rule => rule.events.includes(curr))
          .find(rule => !isValid(value, rule));

        return eventFunction(arg, {
          isValid: !failedRule,
          ...(failedRule || {}),
        });
      },
    };
  }, {});
};

const ValidatedInput = props => {
  // eslint-disable-next-line no-unused-vars
  const { validation, options, ...restProps } = props;

  return <ThemedInput {...restProps} {...buildEventHandlers(props)} />;
};

ValidatedInput.propTypes = {
  validation: PropTypes.arrayOf(
    PropTypes.shape({
      pattern: PropTypes.any,
      checkValid: PropTypes.func,
      events: PropTypes.arrayOf(PropTypes.string),
      restrictInput: PropTypes.bool,
      message: PropTypes.string,
    })
  ),
};

export default ValidatedInput;



// WEBPACK FOOTER //
// ./src/common/components/ValidatedInput/index.js